import gsap, { Expo, Power2 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { SplitText } from 'gsap/all';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Maths } from '../_app/cuchillo/utils/Maths';

class ScrollItem__BlockDefault extends Scroll_Item {
  _titles = [];
  _buttons = [];

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.timeline = gsap.timeline({ paused: true });
    this.delay = 0;
    [...GetBy.class("__titleShow", __link)].map(dom => this.setupTitleShow(dom));
    [...GetBy.class("__textShow", __link)].map(dom => this.setupShowText(dom));
    this.delay = 0;
    [...GetBy.class("__textScale", __link)].map(dom => this.setupScaleText(dom));
        

    // title-torcido: JS wraps content in <span> (mask), animates span width, fades p
    const titles = GetBy.class('title-torcido', __link);
    for (let i = 0; i < titles.length; i++) {
      const title = titles[i];
      title.innerHTML = `<span>${title.innerHTML}</span>`;
      const span = GetBy.selector('span', title)[0];
      const p = GetBy.selector('p', title)[0];
      const finalW = p ? p.offsetWidth : span.offsetWidth;
      const finalH = p ? p.offsetHeight : span.offsetHeight;
      gsap.set(span, { width: 0, height: finalH });
      if (p) gsap.set(p, { opacity: 0 });
      this._titles.push({ span, p, finalW, finalH });
    }

    // button-torcido: same structure — <a> is the mask (overflow:hidden, no padding),
    // inner <span> has padding + text (mirrors title-torcido's <p>).
    // Animate <a> width 0→natural, fade inner span.
    const btns = GetBy.class('button-torcido', __link);
    for (let i = 0; i < btns.length; i++) {
      const btn = btns[i];
      const span = GetBy.selector('span', btn)[0];
      // Botons multilínia (--constrained, white-space:normal): fixem l'amplada del <span>
      // a la seva mida final ABANS d'encongir la màscara. Així el text manté el seu wrap
      // (p.ex. 2 línies) i la reveal el descobreix com una cortina, sense reflow 1↔2 línies.
      const constrained = btn.classList.contains('--constrained');
      if (constrained && span) gsap.set(span, { width: span.offsetWidth });
      const finalW = btn.offsetWidth;
      const finalH = btn.offsetHeight;
      gsap.set(btn, { width: 0, height: finalH });
      if (span) gsap.set(span, { opacity: 0 });
      this._buttons.push({ btn, span, finalW, finalH, constrained });
    }

    this.onShow = () => {
      this.showCb();
    };
    this.onHide = () => { };
    this.onMove = () => { };
  }

  setupTitleShow(dom) {
      const text = new SplitText(dom, {
          type: 'words',
          wordsClass: 'word-child'
      }).words;

      let delay = this.delay;
      text.map(dom => {

        if(Maths.maxminRandom(10,0) > 7) {
          const margin = Maths.maxminRandom(30, 10)/10;
          dom.style.marginLeft = `${margin}em`;
        }

        this.timeline.from(dom, {
          y: "300%",
          duration: 1,
          rotate: 20,
          force3D: true,
          ease: Ease.EASE_CUCHILLO_IN_OUT
        }, delay);

        delay += 0.08;
      });
  }

  setupScaleText(dom) {
      const text = new SplitText(dom, {
          type: 'words',
          wordsClass: 'word-child'
      }).words;

      let delay = this.delay;
      Functions.arrayRandom(text).map(dom => {
          this.timeline.from(dom, {
              alpha: 0,
              duration: .01,
              force3D: true,
              ease: Power2.easeIn
          }, delay);

          this.timeline.from(dom, {
              scaleX: 3,
              scaleY: 3,
              duration: .3,
              force3D: true,
              ease: Expo.easeIn
          }, delay);

          delay += 0.1;
      });

      this.delay += .5;
  }

  setupShowText(dom) {
      const text = new SplitText(dom, {
            type: 'words',
            wordsClass: 'word-child'
        }).words;

        let delay = this.delay;
        let time = .1;
        text.map(dom => {
            this.timeline.from(dom, {
                alpha: 0,
                duration: .4 + time,
                force3D: true,
                ease: Power2.easeOut
            }, delay);

            time += 0.12;
            delay += 0.03;
        });

      this.delay += .5;
  }

  showCb() {
    this.timeline.restart();

    this._titles.forEach(({ span, p, finalW, finalH }) => {
      gsap.to(span, {
        width: finalW,
        duration: 1.5, delay: 1.5, ease: 'power3.out',
        onComplete: () => gsap.set(span, { clearProps: 'width,height' })
      });
      if (p) gsap.to(p, {
        opacity: 1,
        duration: 0.1, delay: 1.6,
        onComplete: () => gsap.set(p, { clearProps: 'opacity' })
      });
    });

    this._buttons.forEach(({ btn, span, finalW, finalH, constrained }) => {
      gsap.to(btn, {
        width: finalW,
        duration: 1.5, delay: 1.5, ease: 'power3.out',
        onComplete: () => {
          gsap.set(btn, { clearProps: 'width,height' });
          // Alliberem l'amplada fixada del <span> només quan la màscara ja és plena,
          // per no provocar un reflow a mitja animació.
          if (constrained && span) gsap.set(span, { clearProps: 'width' });
        }
      });
      if (span) gsap.to(span, {
        opacity: 1,
        duration: 0.1, delay: 1.6,
        onComplete: () => gsap.set(span, { clearProps: 'opacity' })
      });
    });
  }

  resize(__w, __h) {
    super.resize(__w, __h);
  }
}

Scroll._registerClass('BlockDefault', ScrollItem__BlockDefault);

export default ScrollItem__BlockDefault;
